<template>
  <div class="gathercodeApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <headComponent></headComponent>
    <div style="height:36px"></div>
    <img class="codeimg" src="~assets/images/gather.jpg"/>
    <h2>悠乐聚卡激活</h2>
    <ul>
      <li>
        <span>凭证码</span>
        <input type="text" v-model="cardId" placeholder="请输入凭证码" />
        <b @click="getGatherCode">扫码激活<i class="el-icon-arrow-right"></i></b>
      </li>
      <li v-if="cardId != ''">
        <span>手机号</span>
        <input type="text" v-model="phone" placeholder="请输入手机号" />
      </li>
      <li v-if="cardId != ''">
        <span>验证码</span>
        <input type="text" v-model="yzm" placeholder="请输入验证码" />
        <font :style="pat == true ? 'background:#ccc;color:#555' : ''" @click="sendReg">{{sendSns}}</font>
      </li>
    </ul>
    <div class="btnCode">
      <a @click="$router.push('gatherscenic')">预约参加</a>
      <a @click="saveGatherCode">激活悠乐聚卡</a>
    </div>
    <div class="notice">
      <p>1、请在悠乐聚卡激活有效期内激活年卡，超过悠乐聚卡激活有效期后，悠乐聚卡将自动作废;</p>
      <p>2、悠乐聚卡激活后将不可退款、悠乐聚卡作废后不可退款;</p>
      <p>3、悠乐聚卡激活后，开始计算使用有效期;</p>
    </div>
  </div>
</template>

<script> 
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        userData:[],
        baseUrl:'',
        code:'',
        cardId:'',
        phone:'',
        yzm:'',
        sendSns:'获取验证码',
        pat:false,
      };
    },

    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/gathercode');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      saveGatherCode:function(){
        var that = this;
        if(that.cardId == ''){
          that.$alert('请输入凭证码','提示');
          return false;
        }
        if(that.phone == ''){
          that.$alert('请输入手机号','提示');
          return false;
        }
        if(that.yzm == ''){
          that.$alert('请输入验证码','提示');
          return false;
        }
        that.fullscreenLoading = true;

        that.$confirm('是否确认激活游卡?', '温馨提醒', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          $.ajax({
            type:'post',
            url:that.$host+'home/gather/getGatherPan',
            data:{
              cardId:that.cardId,
              phone:that.phone,
              yzm:that.yzm,
              user_id:that.userData.id
            },
            dataType:'json',
            success:function(data){
              if(data.status == 200){
                that.$router.go(-1)
              }else{
                that.$alert(data.message,'提示');
              }
              that.fullscreenLoading = false;
            }
          })
        }).catch(() => {
          that.fullscreenLoading = false;
        });
        
      },
      sendReg:function(){
        if(this.pat == true){
          return false;
        }
        if(this.phone == ''){
          this.$alert('请输入手机号码', '提示');
          return false;
        }
        let reg = /^1[0-9]{10}$/
        if(!reg.test(this.phone)){
          this.$alert('请输入正确的手机号码', '提示');
          return false;
        }
        var that = this;
        $.ajax({
          type:'post',
          url:that.$host+'home/gather/codeSms',
          data:{
            phone:that.phone
          },
          dataType:'json',
          success:function(data){
            if(data.status == 200){
              that.pat = true;
              var i = 60
              let time = setInterval(() => {
                i--
                if(i < 1){
                  this.sendSns = '获取验证码';
                  clearInterval(time)
                  this.pat = false;
                  return false;
                }
                this.sendSns = i+'秒后重试';
                this.flag = true
              }, 1000)
            }else{
              that.$alert(data.message,'提示');
            }
            that.fullscreenLoading = false;
          }
        })
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      getGatherCode:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'checkJsApi',
              'scanQRCode'
            ]
          });
          wx.ready(function() {
            wx.checkJsApi({
              jsApiList: ['scanQRCode'],
              success: function (res) {
                if (res.checkResult.scanQRCode === true) {
                  wx.scanQRCode({
                    desc: 'scanQRCode desc',
                    needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                    scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                    success: function (res) {
                      that.cardId = res.resultStr
                    }, 
                    fail : function(res) { 
                    } 
                  });
                }else {
                  alert('抱歉，当前客户端版本不支持扫一扫')
                }
              }
            });
          });
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:80%
  }
  .gathercodeApp{
    max-width:640px;
    margin:0 auto;
    background:#ececec;
  }
  .gathercodeApp .codeimg{
    display:block;
    width:100%;
    object-fit: cover;
    height:250px;
  }
  .gathercodeApp h2{
    width:94%;
    margin: 0 auto;
    font-size:16px;
    padding:12px 0
  }
  .gathercodeApp ul{
    background:#fff;
    width:94%;
    margin: 0 auto 30px auto;
    border-radius:6px;
  }
  .gathercodeApp ul li{
    height:50px;
    width:100%;
    border-bottom:1px solid #ededed;
    position:relative;
  }
  .gathercodeApp ul li:last-child{
    border-bottom:none;
  }
  .gathercodeApp ul li span{
    float:left;
    height:50px;
    line-height:50px;
    width:65px;
    text-align:right;
    font-size:15px;
    color:#1C222B
  }
  .gathercodeApp ul li input{
    outline:none;
    height:50px;
    float:left;
    width:calc(100% - 89px);
    border:none;
    padding:0 12px;
    font-size:15px;
    color:#1C222B
  }
  .gathercodeApp ul li b{
    position:absolute;
    color: #499FFF;
    top:7.5px;
    right:12px;
    height:35px;
    font-size:14px;
    line-height:35px;
    border-radius:35px;
    font-weight:normal
  }
  .gathercodeApp ul li font{
    position:absolute;
    background: linear-gradient(90deg, #70B5FF, #499FFF);
    top:10px;
    right:12px;
    height:30px;
    font-size:14px;
    line-height:30px;
    color:#fff;
    padding:0 12px;
    border-radius:30px;
  }
  .gathercodeApp .btnCode{
    width:94%;
    margin: 0 auto;
    text-align:center;
  }
  .gathercodeApp .btnCode a{
    display:inline-block;
    width:43%;
    height:40px;
    background: linear-gradient(90deg, #70B5FF, #499FFF);
    margin:0 auto 20px auto;
    border-radius:35px;
    text-align:center;
    line-height:40px;
    color:#fff;
    font-size:15px;
    border:solid 1px #499FFF;
  }
  .gathercodeApp .btnCode a:first-child{
    background:none;
    color:#499FFF;
    margin-right:5%
  }
  .gathercodeApp .notice{
    width:94%;
    margin: 0 auto;
  }
  .gathercodeApp .notice p{
    font-size:13px;
    color:#6b6b6b;
    text-align: justify;
    line-height:22px;
    padding-top:5px
  }
</style>